export function initAnchorSmoothScroll() {
    const header = document.querySelector('#header');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    function getHeaderOffset() {
        if (!header) return 0;
        return header.getBoundingClientRect().height;
    }

    function getHashFromLink(link) {
        const href = link.getAttribute('href');
        if (!href) return null;

        if (href.startsWith('#')) {
            return href;
        }

        const url = new URL(href, window.location.href);
        const isSamePage = url.origin === window.location.origin && url.pathname === window.location.pathname;

        if (!isSamePage || !url.hash) {
            return null;
        }

        return url.hash;
    }

    function getTargetElement(hash) {
        if (!hash || hash === '#') return null;

        const targetId = decodeURIComponent(hash.slice(1));
        if (!targetId) return null;

        const targetById = document.getElementById(targetId);
        if (targetById) return targetById;

        return document.querySelector(`[name="${targetId}"]`);
    }

    function scrollToTarget(target) {
        const offsetTop = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
        window.scrollTo({
            top: Math.max(offsetTop, 0),
            behavior: reducedMotionQuery.matches ? 'auto' : 'smooth'
        });
    }

    document.addEventListener('click', (event) => {
        if (event.defaultPrevented) return;

        const link = event.target.closest('a');
        if (!link) return;

        const targetValue = link.getAttribute('target');
        if (targetValue && targetValue !== '_self') return;

        const hash = getHashFromLink(link);
        if (!hash) return;

        const target = getTargetElement(hash);
        if (!target) return;

        event.preventDefault();
        history.pushState(null, '', hash);
        scrollToTarget(target);
    });

    if (window.location.hash) {
        const initialTarget = getTargetElement(window.location.hash);
        if (initialTarget) {
            scrollToTarget(initialTarget);
        }
    }
}
